export default __webpack_public_path__ + "static/media/mSizeLogo.d0fdca7f.svg";